<template>
  <label
    class="rounded-md border p-2 py-1.5 flex items-center justify-between gap-3 cursor-pointer hover:border-primary duration-300"
    :class="selected ? 'border-primary' : 'dark:border-surface-700'"
  >
    <span
      class="grid shrink-0 place-content-center bg-primary text-surface-0 h-8 w-8 sm:h-9 sm:w-9 rounded-md"
    >
      <svg
        class="shrink-0 fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        height="24"
        width="24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 22v-5M9 8V2m6 6V2m3 6v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z"
        />
      </svg>
    </span>
    <div class="grow">
      <p class="font-medium leading-snug">
        {{ userOrganizations.name || userOrganizations.id || platform }}
      </p>
      <div class="flex items-center gap-1.5">
        <span
          class="bg-surface-200 grid h-5 w-5 place-content-center rounded-full overflow-hidden dark:bg-surface-700"
        >
          <i class="pi pi-building text-xs"></i>
        </span>
        <p class="text-sm opacity-80">
          {{ userOrganizations.vanityName || userOrganizations.name }}
        </p>
      </div>
    </div>

    <input
      v-model="selected"
      type="checkbox"
      class="form-checkbox duration-300"
      name="integration"
    />
  </label>
</template>

<script setup lang="ts">
import type { IntegrationTypes, ILinkedInOrganization } from "@/types/account";

defineProps<{
  platform: IntegrationTypes;
  userOrganizations: ILinkedInOrganization;
}>();

const selected = defineModel<boolean>();
</script>
